import { useLocation } from "react-router-dom";

const noSidebarPaths = [
  "/",
  "/Guest",
  "/GuestCheckout",
  "/Login",
  "/CashReceipt",
  "/CashReceiptA4",
  "/PrintKOT",
  "CashierMobile",
  "/ModuleTransfer",
  "/ErrorPage",
  "/RemoteApprovals",
  "/RemoteApprovals/",
];

const HideSidebar = () => {
  const location = useLocation();
  return noSidebarPaths.includes(location.pathname);
};

export default HideSidebar;
